var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    const accordionIcons = this.querySelectorAll(".accordion-icon");
    accordionIcons.forEach((icon) => {
      console.log(icon);
      icon.classList.toggle("display-none");
    })
    console.log(accordionIcons); 
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}